export default __webpack_public_path__ + "static/media/withdraw_logo.34b48214.webp";